import React, { useState, useEffect } from 'react'
import Filters from '../../../components/Headers/Filters'
import {
  Row,
  Col,
  Input,
  FormGroup,
  ButtonGroup,
  Button,
} from 'reactstrap'
import classnames from 'classnames'

const TIPOS = [
  { value: '', label: 'Todos' },
  { value: 'info', label: 'Informação' },
  { value: 'success', label: 'Sucesso' },
  { value: 'warning', label: 'Aviso' },
  { value: 'danger', label: 'Erro / Crítico' },
]

export default ({ load, presets, actions, ...props }) => {
  const [titulo, setTitulo] = useState('')
  const [tipo, setTipo] = useState('')
  const [status, setStatus] = useState('')
  const [runLoad, setRunLoad] = useState(props.search ? props.search : true)

  useEffect(() => {
    if (runLoad) {
      search()
      setRunLoad(false)
    }
  }, [runLoad])

  useEffect(() => {
    if (!runLoad) {
      search()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, tipo])

  function search() {
    load({
      titulo,
      tipo,
      ativo: status === '' ? undefined : status === 'A',
    })
  }

  function handleClearFilter() {
    setTitulo('')
    setTipo('')
    setStatus('')
  }

  return (
    <Filters
      onSearch={search}
      title={<h1>Alertas do Sistema</h1>}
      onFiltersClead={handleClearFilter}
      presets={() => (
        <>
          <ButtonGroup className="btn-group-toggle mr-3" size="sm" data-toggle="buttons">
            {[
              { id: '', text: 'Todos' },
              { id: 'A', text: 'Ativos' },
              { id: 'I', text: 'Inativos' },
            ].map((item) => (
              <Button
                key={item.id}
                className={classnames({ active: status === item.id })}
                color="secondary"
                onClick={() => setStatus(item.id)}
              >
                {item.text}
              </Button>
            ))}
          </ButtonGroup>
          {presets && presets()}
        </>
      )}
      actions={actions}
    >
      <Row className="py-4">
        <Col lg={6} md={12}>
          <FormGroup>
            <label className="form-control-label">Título</label>
            <Input
              className="form-control-alternative"
              placeholder="Título..."
              type="text"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col lg={6} md={12}>
          <FormGroup>
            <label className="form-control-label">Tipo</label>
            <Input
              className="form-control-alternative"
              type="select"
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
            >
              {TIPOS.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>
    </Filters>
  )
}
